<template>
  <div class="pop-one">

    <div v-if="(factData.depth !== undefined)" class="select-bar">
      <div
        :class="['select-btn', 'first', {'selected': (lvlSelect === 1)}]"
        v-touch:tap="setLvl(1)"
      >
        <h4>{{$lang.base_lvl}}</h4>
      </div>
      <div
        :class="['select-btn', 'second', {'selected': (lvlSelect === 2)}]"
        v-touch:tap="setLvl(2)"
      >
        <h4>{{$lang.depth_lvl}}</h4>
      </div>
    </div>

    <div class="a-box beige">
      <div class="pure-g">
        <div class="pure-u-1-1 pure-u-md-1-2 fixed-text-box">
          <h2 v-html="$lang[factData.header.header]"></h2>
          <p v-show="lvlSelect === 1" v-html="$lang[factData.header.ingress]"></p>
          <p v-show="lvlSelect === 2" v-html="$lang[factData.header.ingress_depth]"></p>
        </div>
        <div class="pure-u-1-2 pure-u-md-1-2 icon-holder">
          <div :class="['icon', (factData.header.icon)]"></div>
        </div>
      </div>
    </div>

    <div class="p-section maroon">
      <div class="p-box close-bottom pure-g">
        <div class="box-left pure-u-1-1 pure-u-md-1-2">
          <h2 v-html="$lang[factData.gen.sec_header]"></h2>
        </div>
        <div class="pure-u-1-1 pure-u-md-1-2"></div>
      </div>
    </div>

    <!-- Content part base -->
    <div v-if="lvlSelect === 1" class="lvl-section regular">
      <div class="pure-g">
        <div class="lvl-box pure-u-1-1 pure-u-md-1-3">
          <div class="lvl-header">
            <div :class="['icon', (factData.gen.col_1_icon)]"></div>
            <h4 v-html="$lang[factData.gen.col_1_header]"></h4>
          </div>
          <div class="lvl-body" v-html="$lang[factData.base.col_1_txt]"></div>
        </div>
        <div class="lvl-box pure-u-1-1 pure-u-md-1-3">
          <div class="lvl-header">
            <div :class="['icon', (factData.gen.col_2_icon)]"></div>
            <h4 v-html="$lang[factData.gen.col_2_header]"></h4>
          </div>
          <div class="lvl-body" v-html="$lang[factData.base.col_2_txt]"></div>
        </div>
        <div class="lvl-box pure-u-1-1 pure-u-md-1-3">
          <div class="lvl-header">
            <div :class="['icon', (factData.gen.col_3_icon)]"></div>
            <h4 v-html="$lang[factData.gen.col_3_header]"></h4>
          </div>
          <div class="lvl-body" v-html="$lang[factData.base.col_3_txt]"></div>
        </div>
      </div>
    </div>

    <!-- Content part depth -->
    <div v-if="(lvlSelect === 2 && factData.depth !== undefined)" class="lvl-section regular depth">
      <div class="pure-g">
        <div class="lvl-box pure-u-1-1 pure-u-md-1-3">
          <div class="lvl-header">
            <div :class="['icon', (factData.gen.col_1_icon)]"></div>
            <h4 v-html="$lang[factData.gen.col_1_header]"></h4>
          </div>
          <div class="lvl-body before-info" v-html="$lang[factData.depth.col_1_txt]"></div>
          <div class="lvl-info" v-for="(col, i) in factData.depth.col_1_blocks" :key="i">
            <div v-if="(col.header !== undefined)" class="info-header">
              <h4>{{$lang[col.header]}}</h4>
            </div>
            <div v-if="(col.ingress !== undefined)" class="info-ingress" v-html="$lang[col.ingress]"></div>
            <div v-for="(row, y) in col.rows" :key="y" :class="['info-block', {'selected': (leftSel === (i + '-' + y))}]">
              <div class="block-h" v-touch:tap="selectAcc(1, i, y)">
                <div class="icon turk-arrow"></div>
                <h5 v-html="$lang[row.head]"></h5>
              </div>
              <transition name="open-it">
                <div v-show="leftSel === (i + '-' + y)" class="block-c" v-html="$lang[row.txt]"></div>
              </transition>
            </div>
          </div>
        </div>
        <div class="lvl-box pure-u-1-1 pure-u-md-1-3">
          <div class="lvl-header">
            <div :class="['icon', (factData.gen.col_2_icon)]"></div>
            <h4 v-html="$lang[factData.gen.col_2_header]"></h4>
          </div>
          <div class="lvl-body before-info" v-html="$lang[factData.depth.col_2_txt]"></div>
          <div class="lvl-info" v-for="(col, i) in factData.depth.col_2_blocks" :key="i">
            <div v-if="(col.header !== undefined)" class="info-header">
              <h4>{{$lang[col.header]}}</h4>
            </div>
            <div v-if="(col.ingress !== undefined)" class="info-ingress" v-html="$lang[col.ingress]"></div>
            <div v-for="(row, y) in col.rows" :key="y" :class="['info-block', {'selected': (centerSel === (i + '-' + y))}]">
              <div class="block-h" v-touch:tap="selectAcc(2, i, y)">
                <div class="icon turk-arrow"></div>
                <h5 v-html="$lang[row.head]"></h5>
              </div>
              <transition name="open-it">
                <div v-show="centerSel === (i + '-' + y)" class="block-c" v-html="$lang[row.txt]"></div>
              </transition>
            </div>
          </div>
        </div>
        <div class="lvl-box pure-u-1-1 pure-u-md-1-3">
          <div class="lvl-header">
            <div :class="['icon', (factData.gen.col_3_icon)]"></div>
            <h4 v-html="$lang[factData.gen.col_3_header]"></h4>
          </div>
          <div class="lvl-body before-info" v-html="$lang[factData.depth.col_3_txt]"></div>
          <div class="lvl-info" v-for="(col, i) in factData.depth.col_3_blocks" :key="i">
            <div v-if="(col.header !== undefined)" class="info-header">
              <h4>{{$lang[col.header]}}</h4>
            </div>
            <div v-if="(col.ingress !== undefined)" class="info-ingress" v-html="$lang[col.ingress]"></div>
            <div v-for="(row, y) in col.rows" :key="y" :class="['info-block', {'selected': (rightSel === (i + '-' + y))}]">
              <div class="block-h" v-touch:tap="selectAcc(3, i, y)">
                <div class="icon turk-arrow"></div>
                <h5 v-html="$lang[row.head]"></h5>
              </div>
              <transition name="open-it">
                <div v-show="rightSel === (i + '-' + y)" class="block-c" v-html="$lang[row.txt]"></div>
              </transition>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="p-section maroon">
      <div class="p-box close-bottom pure-g">
        <div class="box-left pure-u-1-1 pure-u-md-1-2" v-touch:tap="toggleRefs">
          <h2 class="toggle-ref">{{$lang.refs}} <span :class="{'open': showRefs}"></span></h2>
        </div>
        <div class="pure-u-1-1 pure-u-md-1-2"></div>
      </div>
    </div>

    <!-- Refferens -->
    <div class="lvl-section refs">
      <transition name="show-ref">
        <div v-show="showRefs" class="pure-g refs-container">
          <div :class="['lvl-box', 'refs', 'pure-u-1-1', ('pure-u-md-1-' + factData.refs_nbr)]">
            <div
              v-if="(factData.refs.col_1_ref !== undefined)"
              :class="['lvl-body', ((factData.refs_class !== undefined && factData.refs_class.class_one !== undefined) ? factData.refs_class.class_one : '')]"
              v-html="$lang[factData.refs.col_1_ref]"
            ></div>
          </div>
          <div :class="['lvl-box', 'refs', 'pure-u-1-1', ('pure-u-md-1-' + factData.refs_nbr)]">
            <div
              v-if="(factData.refs.col_2_ref !== undefined)"
              :class="['lvl-body', ((factData.refs_class !== undefined && factData.refs_class.class_two !== undefined) ? factData.refs_class.class_two : '')]"
              v-html="$lang[factData.refs.col_2_ref]"
            ></div>
          </div>
          <div v-if="factData.refs_nbr === 3" :class="['lvl-box', 'refs', 'pure-u-1-1', ('pure-u-md-1-' + factData.refs_nbr)]">
            <div
              v-if="(factData.refs.col_3_ref !== undefined)"
              :class="['lvl-body', ((factData.refs_class !== undefined && factData.refs_class.class_three !== undefined) ? factData.refs_class.class_three : '')]"
              v-html="$lang[factData.refs.col_3_ref]"
            ></div>
          </div>
        </div>
      </transition>
    </div>

  </div>
</template>

<script>
export default {
  name: 'pop-fact',
  data () {
    return {
      lvlSelect: 1,
      leftSel: -1,
      centerSel: -1,
      rightSel: -1,
      showRefs: false
    }
  },
  props: {
    factData: {
      type: Object,
      required: true
    }
  },
  methods: {
    toggleRefs () {
      let self = this
      return self.onToggleRefs()
    },
    onToggleRefs () {
      this.showRefs = !this.showRefs
    },
    setLvl (nr) {
      let self = this
      return () => {
        self.onSetLvl(nr)
      }
    },
    onSetLvl (nr) {
      this.lvlSelect = nr
    },
    selectAcc (row, acc, id) {
      let self = this
      return () => {
        self.onSelectAcc(row, acc, id)
      }
    },
    onSelectAcc (row, acc, id) {
      if (row === 1) {
        if (this.leftSel === (acc + '-' + id)) {
          this.leftSel = -1
        } else {
          this.leftSel = (acc + '-' + id)
        }
      } else if (row === 2) {
        if (this.centerSel === (acc + '-' + id)) {
          this.centerSel = -1
        } else {
          this.centerSel = (acc + '-' + id)
        }
      } else if (row === 3) {
        if (this.rightSel === (acc + '-' + id)) {
          this.rightSel = -1
        } else {
          this.rightSel = (acc + '-' + id)
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/popups/pop-facts/index.vue